import { combineReducers } from 'redux'

import demographics from 'src/store/modules/patient/demographics'
import profile from 'src/store/modules/patient/profile'
import program from 'src/store/modules/patient/program'
import courses from 'src/store/modules/patient/courses'
import activityLog from 'src/store/modules/patient/activityLog'
import pathways from 'src/store/modules/patient/pathways'
import gamification from 'src/store/modules/patient/gamification'
import measurements from 'src/store/modules/patient/measurements'
import medications from 'src/store/modules/patient/medications'
import carePlan from 'src/store/modules/patient/carePlan'
import externalDocuments from 'src/store/modules/patient/externalDocuments'
import dashboard from 'src/store/modules/patient/dashboard'
import medicalDevices from 'src/store/modules/patient/medicalDevices'

export default combineReducers({
  demographics,
  profile,
  program,
  courses,
  activityLog,
  pathways,
  gamification,
  measurements,
  medications,
  carePlan,
  externalDocuments,
  dashboard,
  medicalDevices
})

export * from 'src/store/modules/patient/selectors'
export * from 'src/store/modules/patient/demographics'
export * from 'src/store/modules/patient/profile'
export * from 'src/store/modules/patient/program'
export * from 'src/store/modules/patient/courses'
export * from 'src/store/modules/patient/activityLog'
export * from 'src/store/modules/patient/pathways'
export * from 'src/store/modules/patient/measurements'
export * from 'src/store/modules/patient/medications'
export * from 'src/store/modules/patient/carePlan'
export * from 'src/store/modules/patient/gamification'
export * from 'src/store/modules/patient/externalDocuments'
export * from 'src/store/modules/patient/dashboard'
export * from 'src/store/modules/patient/medicalDevices'
